import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Col, Container, Row } from 'react-bootstrap';


import { useLocalization } from '../../contexts/LocalizationContext';


const TestPDP = () => {
    const navigate = useNavigate();
    const [inputValue, setInputValue] = useState('161');
    const [productType, setProductType] = useState('PHYSICAL');
    const [env, setEnv] = useState('stg');
    const { locale, localeWith_, defaultCurrency } = useLocalization();


    useEffect(() => {
        let host = window.location.hostname;
        if (host !== "marketplace.nvidia.com") {
            setEnv(host.split(".")[0].split("-")[0])
        } else {
            navigate(`/${locale}/software/cart/`);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (sessionStorage.getItem('cartInitiated') === 'true') {
            const pid = sessionStorage.getItem('pid');
            const prodType = sessionStorage.getItem('productType');
            sessionStorage.removeItem('cartInitiated');
            sessionStorage.removeItem('pid');
            addToCart(pid, prodType)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const addToCart = async (pid?: any, prodType?: any) => {
        try {
            await fetch(`https://${env}-api.store.nvidia.com/ucc-software/v2/cart/active`, {
                headers: {
                    "accept": "application/json, text/javascript, */*; q=0.01",
                    "content-type": "application/json",
                    "partner": "true",
                    "nvidia-client": "true",
                    "sec-ch-ua": "\"Not(A:Brand\";v=\"99\", \"Google Chrome\";v=\"133\", \"Chromium\";v=\"133\"",
                    "sec-ch-ua-mobile": "?0",
                    "sec-ch-ua-platform": "\"macOS\"",
                    "x-queueit-ajaxpageurl": `https%3A%2F%2F${env}-marketplace.nvidia.com%2F${locale}%2Fpdp`
                },
                referrer: `https://${env}-marketplace.nvidia.com/`,
                referrerPolicy: "strict-origin-when-cross-origin",
                body: JSON.stringify({
                    "cart": {
                        "products": [
                            {
                                "productId": pid || inputValue,
                                "quantity": 1
                            }
                        ],
                        "isDigital": prodType && prodType === 'DIGITAL' ? true : productType === 'DIGITAL' ? true : false,
                        "currency": defaultCurrency,
                        "locale": localeWith_,

                        "custom_fields": ((prodType && prodType === 'DIGITAL') || productType === 'DIGITAL') ? [
                            {
                                "productId": "86220",
                                "firstname": "testFirst",
                                "lastname": "testLast",
                                "email": "test123@nvidia.com"
                            }
                        ] : []
                    }

                }),
                method: "POST",
                mode: "cors",
                credentials: "include"
            });
            window.location.href = `/${locale}/software/cart`;
        } catch (error) {
            console.error('Error adding to cart:', error);
        }
    }

    const handleAddToCart = async (event) => {
        event.preventDefault();
        sessionStorage.setItem('cartInitiated', 'true');
        sessionStorage.setItem('pid', inputValue);
        sessionStorage.setItem('productType', productType);
        addToCart();
    };

    useEffect(() => {
        let interceptDomain = "api.store.nvidia.com";
        let domain_prefix = window.location.host.split(".")[0];
        if (domain_prefix !== "marketplace" && domain_prefix !== "dev") {
            interceptDomain = domain_prefix.split("-")[0] + "-" + interceptDomain;
        }
        let queueit_client = document.createElement('script');
        queueit_client['src'] = '//static.queue-it.net/script/queueclient.min.js';
        queueit_client.type = 'text/javascript';
        document.getElementsByTagName('head')[0].appendChild(queueit_client);
        let queueit_config = document.createElement('script');
        queueit_config.src = '//static.queue-it.net/script/queueconfigloader.min.js';
        queueit_config.type = 'text/javascript';
        queueit_config.setAttribute("data-queueit-c", "nvidia");
        queueit_config.setAttribute('data-queueit-intercept-domain', interceptDomain);
        queueit_config.setAttribute('data-queueit-intercept', "true");
        document.getElementsByTagName('head')[0].appendChild(queueit_config);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Container className='testPDP' style={{ marginTop: '100px' }}>
            <Row>
                <Col md={4}><label htmlFor="productType">Product Type: </label></Col>

                <Col md={4}><select id="productType" value={productType} onChange={(e) => setProductType(e.target.value)}>
                    <option value="PHYSICAL">Physical</option>
                    <option value="DIGITAL">Digital</option>
                </select></Col>
            </Row>
            <Row>
                <Col md={4}><label htmlFor="productId">Product ID: </label></Col>
                <Col md={4}><input
                    id="productId"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)} />
                </Col>
            </Row>

            <Row>
                <Col md={4}><button onClick={handleAddToCart}>Add to Cart</button></Col>
            </Row>
        </Container>
    );
};

export default TestPDP;